module.exports = __webpack_public_path__ + "img/ปลาทรายขาว.1738dd2c.jpg";